import ScrollAnimation from "react-animate-on-scroll";
import "./testimonial-card.css";

export default function TestimonialCard({ name, title, quote, fromPage, index, length }: {
  name: string,
  title: string,
  quote: string,
  fromPage: boolean,
  index: number,
  length :number
}) {
  return (
    fromPage ? (
      <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
      <div className={`ae-testimonial-card-container -light-theme -fade-in -from-page ${index === length ? "-last" : ""}`}>
        <div className="ae-card-content">
          <p className="ae-testimonial-quote">{quote}</p>
          <div className="ae-testimonial-quoter-details">
            <p className="ae-testimonial-quoter-name">{name}</p>
            <p className="ae-testimonial-quote-title">{title}</p>
          </div>
        </div>
      </div>
      {index < length && 
      <div className="ae-testimonial-card-divider"></div>}
      </ScrollAnimation>
    ) : (
      <div className="ae-testimonial-card-container -light-theme -ae-fade-in">
        <div className="ae-card-content">
          <p className="ae-testimonial-quote">{quote}</p>
          <div className="ae-testimonial-quoter-details">
            <p className="ae-testimonial-quoter-name">{name}</p>
            <p className="ae-testimonial-quote-title">{title}</p>
          </div>
        </div>
      </div>
    )
  )
}